const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const StatsIcon = require("./StatsIcon");
const AssetsUtil = require("../util/AssetsUtil");
const withAnimateRef = require("../hoc/withAnimateRef");
const WebAnimations = require("../util/WebAnimations");

const styles = require("./styles/Stars.css");

const augment = function(Component) {
	Component = withAnimateRef(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "StarsView",

		propTypes: {
			numStars: PT.number.isRequired,
			mainClass: PT.string,
			starClass: PT.string,
			displayAllStars: PT.bool, // if true, display all 3 stars, whether earned or unearned
			earnedStarType: PT.string,
			displayNoStars: PT.bool, //if true, display no star images (so this just makes an empty div with the mainClass name)
			animate: PT.bool, //animate stars one by one (trainer summary page)

			// Injected by HOCs
			animateRef: PT.func.isRequired,
		},

		getDefaultProps: function() {
			return {
				earnedStarType: "trainer",
			};
		},

		componentDidMount: function() {
			const {
				animate,
				numStars,
				animateRef,
				displayNoStars,
				earnedStarType,
			} = this.props;
			if (
				animate &&
				numStars > 0 &&
				!displayNoStars &&
				earnedStarType === "summary"
			) {
				for (let s = 0; s < numStars; s++) {
					animateRef(this.stars["star" + s], WebAnimations.starPop, {
						duration: 500,
						easing: "ease-in",
						iterations: 1,
						delay: s * 400,
					});
				}
			}
		},

		isOffice: function() {
			return this.props.earnedStarType === "office";
		},

		getStar: function(index, isEarned) {
			let starClass = this.props.starClass || "";

			const starNum = this.isOffice() ? 1 : index + 1;

			if (this.props.earnedStarType === "summary") {
				if (this.props.animate && this.props.numStars > 0) {
					starClass += " " + styles.hidden;
				}
				return (
					<img
						key={"star-" + index}
						ref={s => (this.stars["star" + index] = s)}
						className={starClass}
						src={AssetsUtil.getStarEarned(index + 1, isEarned)}
					/>
				);
			} else {
				return (
					<StatsIcon
						key={"star-" + index}
						style={this.isOffice() ? "office" : "trainer"}
						type={"star" + starNum}
						className={starClass}
						disabled={!isEarned}
					/>
				);
			}
		},

		render: function() {
			this.stars = [];
			const {
				numStars,
				displayAllStars,
				displayNoStars,
				mainClass = "",
			} = this.props;

			let stars;
			if (!displayNoStars) {
				if (displayAllStars) {
					stars = _.range(3).map((x, i) => this.getStar(i, i < numStars));
				} else {
					if (numStars === 0) {
						stars = [this.getStar(0, false)];
					} else {
						stars = _.range(numStars).map((x, i) => this.getStar(i, true));
					}
				}
			}

			return <div className={mainClass}>{stars}</div>;
		},
	})
);
